import axios from "axios";
import React, { useContext } from "react";
// import { BASE_URL } from "../constants/api_urls";
import { AuthContext } from "../context/AuthContext";
import { AppStateContext } from "../context/AppContext";
import apiPath from "../constants/apiPath";
import { Severty, ShowToast } from "../helper/toast";
const client = axios.create({
  baseURL: apiPath.baseURL,
});

const useRequest = () => {
  const { logout } = useContext(AuthContext);
  const { setLoading } = useContext(AppStateContext);

  const request = async ({
    url,
    method: tmethod,
    data,
    onSuccess,
    onError,
    header,
    onErrorSubmit,
  }) => {
    const method = tmethod.trim().toUpperCase();
    let token = localStorage.getItem("token")
      ? localStorage.getItem("token")
      : "";

    const headers = {
      ...header,
      Authorization: `Bearer ${token}`,
    };

    setLoading(true);
    try {
      const response = await client({
        url,
        method,
        data,
        headers: { ...headers },
      });

      if (onSuccess) {
        setLoading(false);
        onSuccess(response.data);
      }
      if (onError) {
        setLoading(false);
        console.log(onError, "onError Jay");
      } else {
        onErrorSubmit(response.data);
      }
      setLoading(false);
      return response.data;
    } catch (err) {
      console.log(err);
      if (err?.response?.status === 401) {
        setLoading(false);
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("session_id");
        ShowToast("Logout Successfully", Severty.SUCCESS);
        window.location.assign("/login");
      }
      if (err?.response?.data?.message === "jwt expired") {
        setLoading(false);
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("session_id");
        ShowToast("Logout Successfully", Severty.SUCCESS);
        window.location.assign("/login");
      }
      if (onError) {
        onError(err);
      }
      setLoading(false);
      // throw err;
    } finally {
      setLoading(false);
    }
  };

  return { request };
};

export default useRequest;
